import React, { FC, Fragment, SyntheticEvent } from 'react';
import { TourPackageDeal } from '../../ts/interfaces/OphirResponse';
import { faCalendar, faUser, faUtensils } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMoon } from '@fortawesome/free-regular-svg-icons';
import { formatPriceCurrency } from '@bepro-travel/fe.utils';
import { useNavigate } from 'react-router-dom';
import { Button } from '@bepro-travel/fe.ui';
import { useTranslation } from 'react-i18next';
import { getImgUrl } from '../../utils';
import { cdnUrl, imgBg, soldOutImg } from '../../constants';

interface ResultsListProps {
  list: TourPackageDeal[];
  searchToken: string;
}

const ResultsList: FC<ResultsListProps> = (props) => {

  const [t] = useTranslation() as unknown as [(key: string) => string];
  const navigate = useNavigate();

  const onImageLoadError = ({ currentTarget }: SyntheticEvent<HTMLImageElement, Event>) => {
    currentTarget.onerror = null;
    currentTarget.src = imgBg;
  };

  const goToDetails = (item: TourPackageDeal) => {
    const params = {
      checkIn: item.urlFriendlyCheckIn,
      city: item.city,
      nights: item.nightsCount,
      id: item.id,
      packageId: item.packageId,
      room: item.room,
      dealId: item.id,
      hotelName: item.urlFriendlyHotelName,
      cityCode: item.city,
    };

    const lang = localStorage.getItem('language') || 'he';
    const pathname = lang === 'he' ? '/tour/details' : '/tourru/details';
    sessionStorage.setItem('search' + item.id + item.city + item.urlFriendlyCheckIn, JSON.stringify(item));
    navigate(`${pathname}?` + new URLSearchParams(params as any).toString());
  };

  return (
    <Fragment>
      {props.list.map((item) => (
        <div className="oph-card" key={item.index} onClick={() => goToDetails(item)}>
          <div className="oph-card-img">
            <img
              src={getImgUrl(item.mainPhoto.link, cdnUrl)}
              alt={item.mainPhoto.alt}
              onError={onImageLoadError}
            />
            {item.status === 'RQ' && <img className="oph-card-sold" src={soldOutImg} alt="sold" />}
          </div>
          <div className="oph-card-content">
            <div className="oph-card-title">{item.hotelName}</div>
            <div className="oph-card-facilities">
              <div className="oph-card-facilities-item">
                <FontAwesomeIcon icon={faCalendar as any} />
                {item.checkIn} - {item.checkOut}
              </div>
              <div className="oph-card-facilities-item">
                <FontAwesomeIcon icon={faUtensils as any} />
                {item.boardDescription}
              </div>
              <div className="oph-card-facilities-item">
                <FontAwesomeIcon icon={faMoon as any} />
                {item.nightsCount} {t('tour.nghts')}
              </div>
              {item.guideName && (
                <div className="oph-card-facilities-item">
                  <FontAwesomeIcon icon={faUser as any} />
                  {item.guideName}
                </div>
              )}
            </div>
          </div>
          <div className="oph-card-footer">
            <div className="oph-card-price">
              <span className="price">
                <span className="title">{t('per_person')} / </span>
                {formatPriceCurrency(item.price.onePersonPrice, item.price.currencySymbol)}
              </span>
              <span className="price-sm">
                <span className="title-sm">{t('total')} / </span>
                {formatPriceCurrency(item.price.totalPrice, item.price.currencySymbol)}
              </span>
            </div>
            {item.status === 'RQ' ? (
              <Button
                className="btn btn-danger"
                onClick={() => goToDetails(item)}
                title={t('sold_out')}
              />
            ) : (
              <Button onClick={() => goToDetails(item)} title={t('book')} />
            )}
          </div>
        </div>
      ))}
    </Fragment>
  );
};

export default ResultsList;
